import { useEffect, useState } from "react"
import { injectIntl } from "react-intl"

import React from "react"
import { Async } from "react-select"
import { invoiceFields } from "../../common/search-filter/search/invoiceFilters"
import { isError } from "../../state/helpers/Error"
import { InvoiceService } from "../../state/invoice/services"
import SearchService from "../../state/search/SearchService"
import InvoiceStatusBadge from "../status.component"

type OwnProps = {
    onChange: (id: string, label: string) => void
    id: string
}

const InvoiceSelectionComponent = (props: OwnProps) => {

    const [selectedOptions, setSelectedOptions] = useState({
        id: "",
        label: ""
    })

    useEffect(() => {
        loadInitialInvoice(props.id)
    }, [])

    const loadInvoices = (input, callback) => {

        const postData = {
            keywords: input + "*",
            objects: ["invoices"],
            fields: invoiceFields,
            pageSize: 50,
            activePage: 1,
            sortByField: "identifier",
            sortAsc: false,
            filters: {
                billingType: ["one-time"]
            },
            lightResult: true,
        }

        SearchService.listingSearch(postData).then(res => {
            if (!isError(res)) {
                const opt = res.data.map(invoice => {
                    return {value: invoice.id, projectId: invoice["projectId"],label: <div id="statusBadgeSelection">
                        <b className={"mr-2"}>{invoice["identifier"]}</b>{"- " + invoice["contact"].name}
                        <p>
                            <small>
                                <InvoiceStatusBadge
                                    status={invoice["status"]}
                                    className={"mr-2"}
                                />
                                {"$" + invoice["totalAmount"]}
                            </small>
                        </p>
                    </div>}
                })
                callback(null, {
                    options: opt,
                    complete: false,
                })
            }
        })
    }

    const loadInitialInvoice = (invoiceId: string) => {
        if (invoiceId) {
            InvoiceService.getInvoice(invoiceId).then(res => {
                if (!isError(res)) {
                    setSelectedOptions({
                        id: res.getId(),
                        label: res.getIdentifier()
                    })
                }
            })
        }

    }

    const handleChange = (selectedOptions) => {
        let id = ""
        let label = ""
        let projectId = ""
        if (selectedOptions) {
            id = selectedOptions.value
            label = selectedOptions.label
            projectId = selectedOptions.projectId
        }
        props.onChange(id, projectId)
        setSelectedOptions({
            id: id,
            label: label
        })
    }

    return (
        <Async
            multi={false}
            defaultOptions
            ignoreAccents={false}
            filterOptions={false}
            value={selectedOptions}
            onChange={handleChange}
            onBlurResetsInput={false}
            loadOptions={loadInvoices}
        />
    )
}

export default injectIntl(InvoiceSelectionComponent)


// WEBPACK FOOTER //
// ./src/invoice/components/InvoiceSelectionComponent.tsx